import React, { Fragment } from 'react';
import routes from 'library/Routes';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getTranslate, getActiveLanguage, setActiveLanguage, getLanguages } from 'react-localize-redux';
import { removeUser } from 'actions/actions';
import UserHelper from 'infrastructure/UserHelper';
import { serviceLocator } from 'infrastructure/ServiceLocator';
import LayoutHelper from 'infrastructure/LayoutHelper';
import { withSnackbar } from 'notistack';
import { LanguageSwitcher } from '../Navigation/LanguageSwitcher';
import { withStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { RouteLink } from 'components/Shared/RouteLink';
import { AButton } from 'components/Shared/LinkButton';
import {
  Link,
  Button,
  Avatar,
  AppBar,
  Toolbar,
  MenuItem,
  Divider,
  Hidden,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem
} from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { absoluteRoutes } from '../../library/Routes';


const drawerWidth = 300;

class Header extends React.Component {
  ListItemLink = ({ href, iconTag, children, ...rest }) => (
    <ListItem
      button
      component={RouteLink}
      path={href}
      onClick={this.props.onClose}
      {...rest}
    >
      {iconTag}
      {children}
    </ListItem>
  );
  constructor(props) {
    super(props);
    this.state = { owners: {} };
  }

  componentWillMount() {
    this.loadStudioClientsByPhone();
    this.loadStudioOwners();
  }
  loadStudioOwners = () => {
    if (UserHelper.isLoggedIn(this.props.user))
      for (let i = 0; i < this.props.user.studioClients.length; i++) {
        let studioClient = this.props.user.studioClients[i];
        serviceLocator.userApi
          .getOwnerInfo(studioClient.ownerId)
          .then((owner) => {
            let owners = this.state.owners;
            owners[owner._id] = owner;
            this.setState({ owners: owners });
          }, LayoutHelper.onErrSnack(this.props.enqueueSnackbar));
      }
  };

  loadStudioClientsByPhone = () => {
    if (UserHelper.isLoggedIn(this.props.user)) {
      let api = serviceLocator.clientApi;
      api.getStudioClientsByPhone().then((data) => {
        let studioClients = data.studioClients;
        let owners = data.owners;

        if (studioClients) {
          for (let i = 0; i < studioClients.length; i++) {
            let studioClient = studioClients[i];
            let owner = owners[studioClient.ownerId];
            if (!studioClient.userId) {
              this.props.enqueueSnackbar(
                this.props.translate('myClients.userPhoneInList', {
                  ownerName: owner.name,
                }),
                {
                  variant: 'info',
                  anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                  },
                  action: (key) => {
                    return (
                      <Fragment>
                        <Button
                          onClick={() => {
                            this.connnectClientWithStudioClient(studioClient);
                          }}
                        >
                          {this.props.translate('common.yes')}
                        </Button>
                        <Button
                          onClick={() => {
                            this.props.closeSnackbar(key);
                          }}
                        >
                          {this.props.translate('common.no')}
                        </Button>
                      </Fragment>
                    );
                  },
                }
              );
            }
          }
        }
      }, LayoutHelper.onErrSnack(this.props.enqueueSnackbar));
    }
  };
  connnectClientWithStudioClient = (studioClient) => {
    this.setState({ connectingUsers: true });
    let clientApi = serviceLocator.clientUserApi;
    clientApi.connect(studioClient.ownerId, studioClient._id).then((res) => {
      this.props.toMyStudioClasses(studioClient);
    }, LayoutHelper.onErrSnack(this.props.enqueueSnackbar));
  };

  signOut = (e) => {
    this.props.logOff();
  };
  toMyClients = (e) => {
    this.props.toMyClients();
  };
  toBilling = () => {
    this.props.toBilling();
  };

  UserBlock(user) {
    return this.Student(user);
  }

  Student(user) {
    const { ListItemLink } = this;
    return (
      <Fragment>
        <ListItemLink to={routes.me()}>
          {/*<Avatar src={user.avatar} className={this.props.classes.avatar}>{user.name}</Avatar>*/}
          <AccountCircleIcon className={this.props.classes.avatarIcon} />
          <strong>{user.name}</strong>
        </ListItemLink>
        <ListItemLink to={routes.myAccount()}>
          {this.props.translate('common.myAccount')}
        </ListItemLink>
        <ListItemLink color="inherit" fullWidth to={routes.me()}>
          {this.props.translate('common.myClasses')}
        </ListItemLink>
        <Divider light style={{ opacity: '.5' }} />
        {this.renderMyStudioClients()}
        <Divider light style={{ opacity: '.5' }} />
        <ListItemLink to={routes.changePassword()}>
          {this.props.translate('common.changePassword')}
        </ListItemLink>
        <ListItem
          button
          onClick={() => {
            this.signOut();
          }}
        >
          <a className={this.props.classes.orangeLink}>
            {this.props.translate('common.signOut')}
          </a>
        </ListItem>
      </Fragment>
    );
  }

  renderMyStudioClients = () => {
    if (this.props.user.studioClients.length > 0) {
      const { ListItemLink } = this;
      return this.props.user.studioClients.map((studioClient) => {
        let owner = this.state.owners[studioClient.ownerId];
        if (owner) {
          let link = routes.studioClientClasses({
            ownerId: studioClient.ownerId,
            studioClientId: studioClient._id,
          });
          return (
            <ListItemLink to={link}>
              <Avatar src={owner.avatar} className={this.props.classes.avatar}>
                {owner.name}
              </Avatar>
              {owner.name}
            </ListItemLink>
          );
        }
      });
    }
  };

  SignInBlock() {
    const { ListItemLink } = this;
    if (this.props.domain.domain.allowSignUp) {
      return (
        <ListItemLink to={routes.login()}>
          {this.props.translate('common.signIn')}
        </ListItemLink>
      );
    }
  }

  renderBrand = () => {
    if (this.props.domain?.domain?.custom && this.props.domain?.owner?.avatar) {
      return (
        <div className={this.props.classes.logo}>
          <Link href={routes.root()} rel="nofollow">
            <Avatar
              src={this.props.domain?.owner?.avatar}
              className={this.props.classes.avatar}
            />
          </Link>
        </div>
      );
    } else if (this.props.domain?.staticUrl) {
      return (
        <div className={this.props.classes.logo}>
          <Link href={routes.root()} rel="nofollow">
            <Hidden smDown>
              <img
                width="70"
                className="lazyload"
                height="21"
                src={`${this.props.domain.staticUrl}/voopty.png`}
                alt="Voopty Logo"
              />
            </Hidden>
            <Hidden mdUp>
              <img
                className="lazyload"
                height="21"
                src={`${this.props.domain.staticUrl}/voopty-s.png`}
                alt="Voopty Logo"
              />
            </Hidden>
          </Link>
        </div>
      );
    }
  };
  renderSearch = () => {
    const { ListItemLink } = this;
    if (!this.props.domain.domain.custom) {
      return (
        <ListItemLink to={routes.search()} rel="nofollow">
          {this.props.translate('landingHome.btnSearch')}
        </ListItemLink>
      );
    }
  };

  render() {
    const { classes } = this.props;
    const { menuOpen } = this.state;
    return (
      <Fragment>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            {this.renderBrand()}

            <div className={this.props.classes.toolbarButtons}>
              {!this.props.domain.domain.custom && !this.props.showPricing && (
                <Button
                  aria-label="search"
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    this.props.toSearch();
                  }}
                >
                  <SearchIcon />
                  {this.props.translate('common.search')}
                </Button>
              )}
              {!this.props.domain.domain.custom && this.props.showPricing && (
                <AButton
                  href="https://landing.voopty.com.ua/tariffs/"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant={LayoutHelper.isMobile() ? 'text' : 'outlined'}
                  color="inherit"
                  fullWidth
                  className={this.props.classes.menuButton}
                >
                  <Typography noWrap variant="subtitle">
                    {this.props.translate('common.pricing')}
                  </Typography>
                </AButton>
              )}
              {UserHelper.isLoggedIn(this.props.user) && (
                <Link href={routes.me()}>
                  <Avatar
                    src={this.props.user.avatar}
                    className={this.props.classes.avatar}
                  >
                    {this.props.user.name}
                  </Avatar>
                </Link>
              )}
              <LanguageSwitcher />
              {(!this.props.domain.domain.custom ||
                this.props.domain.domain.allowSignUp) && (
                <IconButton
                  onClick={() => this.setState({ menuOpen: true })}
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="Menu"
                >
                  <MenuIcon />
                </IconButton>
              )}
            </div>
          </Toolbar>
        </AppBar>

        {this.renderMenu(menuOpen)}
      </Fragment>
    );
  }

  renderMenu = (menuOpen) => {
    const { classes } = this.props;
    return (
      <nav className={classes.drawer}>
        <Drawer
          variant="temporary"
          anchor="right"
          onClose={() => {
            this.setState({ menuOpen: false });
          }}
          classes={{
            paper: classes.drawerPaper,
          }}
          open={menuOpen}
        >
          <List>
            {UserHelper.isLoggedIn(this.props.user)
              ? this.UserBlock(this.props.user)
              : this.SignInBlock()}
            {this.renderSearch()}
            {this.renderBlog()}
            {this.renderJoinUs()}
          </List>
        </Drawer>
      </nav>
    );
  };

  renderJoinUs = () => {
    if (!this.props.domain.domain.custom) {
      return (
        <ListItem>
          <AButton
            href="https://landing.voopty.com.ua/"
            color="primary"
            variant="contained"
            fullWidth
          >
            {this.props.translate('common.joinUs')}
          </AButton>
        </ListItem>
      );
    }
  };
  renderBlog = () => {
    if (this.props.domain.domain.blog) {
      const { ListItemLink } = this;
      return (
        <ListItemLink
          to={this.props.domain.domain.blog}
          rel="nofollow"
          target="_blank"
        >
          {this.props.translate('common.blog')}
        </ListItemLink>
      );
    }
  };

}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  langs: getLanguages(state.locale),
  user: state.user,
  domain: state.domain,
});

const mapDispatchToProps = (dispatch) => {
  return {
    root: () => {
      dispatch(push(`${routes.root()}`));
    },
    toLogin: () => {
      dispatch(push(`${routes.login()}`));
    },
    toMyStudios: () => {
      dispatch(push(`${routes.myStudios()}`));
    },
    toCreateStudio: () => {
      dispatch(push(`${routes.createStudio()}`));
    },
    toSearch: () => {
      dispatch(push(`${routes.search()}`));
    },
    toMyClients: () => {
      dispatch(push(`${routes.myClients()}`));
    },
    toBilling: () => {
      dispatch(push(`${routes.billing()}`));
    },
    toMyExpenses: () => {
      dispatch(push(`${routes.myExpenses()}`));
    },
    toPaymentReport: () => {
      dispatch(push(`${routes.paymentReport()}`));
    },
    toMyAccount: () => {
      dispatch(push(`${routes.myAccount()}`));
    },
    changePassword: () => {
      dispatch(push(`${routes.changePassword()}`));
    },
    logOff: () => {
      let api = serviceLocator.clientUserApi;
      api.killSession();
      dispatch(removeUser());
      dispatch(push(`${routes.login()}`));
    },
    toMyClasses: () => {
      dispatch(push(`${routes.myClasses()}`));
    },
    toMyStudioClasses: (studioClient) => {
      dispatch(
        push(
          `${routes.studioClientClasses({
            ownerId: studioClient.ownerId,
            studioClientId: studioClient._id,
          })}`
        )
      );
    },
    me: () => {
      dispatch(push(`${routes.me()}`));
    },
    removeUser: function () {
      dispatch(removeUser());
    },
    changeLang: function (lang) {
      let api = serviceLocator.clientUserApi;
      api.setLang(lang);
      dispatch(setActiveLanguage(lang));
    },
  };
};

export default absoluteRoutes(
  withSnackbar(
    withStyles((theme) => ({
      appBar: {
        marginLeft: 300,
        width: "100%",
        backgroundColor: "#f5f5f5",
        color: "#424242",
        boxShadow: "none",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
      },
      birthday: {
        flexGrow: 1,
      },
      menuButton: {
        color: "#424242",
      },
      logo: {
        display: "flex",
        flexDirection: "column",
        "& img": {
          width: "100px",
          height: "auto",
        },
      },
      badgeNotification: {
        margin: theme.spacing(2),
        marginRight: theme.spacing(2),
      },
      toolbarButtons: {
        marginLeft: "auto",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
      },
      studioName: {
        maxWidth: "140px",
        maxHeight: "56px",
        padding: "0",
        fontSize: "12px",
        color: "#424242",
      },
      drawerPaper: {
        width: drawerWidth,
        backgroundColor: "#f5f5f5",
        color: "#424242",
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        "& .MuiListItem-root": {
          color: "#424242",
        },
        "& .MuiDivider-root": {
          backgroundColor: "rgba(0, 0, 0, 0.12)",
        },
        "& a": {
          color: "#424242",
          textDecoration: "none",
        },
        // Scrollbar styles
        "&::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "&::-webkit-scrollbar-track": {
          background: "rgba(0, 0, 0, 0.03)",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "rgba(0, 0, 0, 0.1)",
          borderRadius: "4px",
          border: "2px solid #f5f5f5",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "rgba(0, 0, 0, 0.15)",
        },
        // Firefox scrollbar
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.03)",
      },
      drawer: {
        flexShrink: 0,
        [theme.breakpoints.up("md")]: {
          width: drawerWidth,
        },
      },
      avatar: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        margin: theme.spacing(0, 1, 0, 1),
      },
      avatarIcon: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        marginRight: theme.spacing(1),
        color: "#424242",
      },
      orangeLink: {
        color: "#f57c00",
        "&:hover": {
          color: "#f57c00",
          textDecoration: "underline",
        },
      },
      // New styles for better hover effects
      listItem: {
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      },
      button: {
        "&.MuiButton-contained": {
          backgroundColor: "#f57c00",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#f57c00",
          },
        },
        "&.MuiButton-outlined": {
          borderColor: "#424242",
          color: "#424242",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        },
      },
    }))(connect(mapStateToProps, mapDispatchToProps)(Header))
  )
);
